export const carouselSlides = [
  {
    id: 'slide-001',
    title: 'Descubre tu próxima lectura',
    subtitle: 'Miles de libros nuevos y usados al mejor precio',
    buttonText: 'Explorar',
    buttonLink: '/buscar',
    bgColor: '#E8F5F0',
    textColor: '#004632',
  },
  {
    id: 'slide-002',
    title: 'Vende tus libros',
    subtitle: 'Conecta con lectores en toda Costa Rica',
    buttonText: 'Comenzar a vender',
    buttonLink: '/registro',
    bgColor: '#FFF5E6',
    textColor: '#333333',
  },
  {
    id: 'slide-003',
    title: 'Hasta 50% de descuento',
    subtitle: 'En títulos seleccionados de literatura latinoamericana',
    buttonText: 'Ver ofertas',
    buttonLink: '/buscar?categoria=ficcion',
    bgColor: '#FAC8D2',
    textColor: '#004632',
  },
];

export default carouselSlides;
